module.exports = __webpack_public_path__ + "static/media/pm.89993b1f.svg";